import React, { useEffect, useState } from 'react';

import Alert, { useAlert } from 'components/snacks/Alert';

import {Link, useParams} from 'react-router-dom';
import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';
import './factorPrint.css';

import { axiosInstance } from 'api/Api';

const FactorDetail = () => {
  const { factorId } = useParams();
  const [loading, setLoading] = useState(false);
  const [companyInfo, setCompanyInfo] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [factorInfo, setFactorInfo] = useState({});
  const [details, setDetails] = useState('');

  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);

  const getPrice = (price) => {
    return Number(price).toLocaleString();
  };

  const backPage = () => {
    window.history.back(-1);
  };

  //
  useEffect(() => {
    setLoading(true);
    axiosInstance()
      .get(`/get-print-detail?invoice_no=${factorId}`)
      .then((r) => {
        const data = r.data;
        if (data.status === 200) {
          setCompanyInfo(data.company);
          setDetails(data.details);
          setFactorInfo(data.factor_info);
          setUserInfo(data.user);
        } else
        {
          alertStore.AddAlert({
            key: '400',
            message: 'مشکلی پیش آمده است، لطفا بعدا دوباره امتحان کنید',
            severity: 'error',
            auto_hide: true
          });
        }
      })
      .catch(() => {
          alertStore.AddAlert({
            key: '500',
            message: 'مشکلی پیش آمده است، لطفا بعدا دوباره امتحان کنید',
            severity: 'error',
            auto_hide: true
          });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    document.querySelectorAll('.factor_product_desc').forEach((elem) => {
      elem.innerHTML = details;
    });
  }, [loading]);

  //
  return (
    <>
      {loading ? (
        <>
          {loading}
          <div className="modal-body text-center">
            <Box
              sx={{ display: 'flex', marginLeft: '15px' }}
              className={'mx-auto'}
            >
              <CircularProgress className={'mx-auto'} />
            </Box>
          </div>
        </>
      ) : (
        <Box className={`bg-white normal-shadow rounded-lg py-2 px-2 px-lg-10 py-lg-10 mb-5`}>
          {/* **************** MAIN HEADER **************** */}
          <div className="d-flex justify-content-between align-items-center print-none">
            <h5 className="m-0">جزییات فاکتور</h5>
            <div className={`d-flex gap-4`}>
              <button
                className={'btn btn-sm btn-primary'}
                onClick={() => window.print()}
              >
                پرینت
              </button>

              {factorInfo?.status == 0 && (
                  <Link
                      to={`/factors/payment/${factorInfo.invoice_no}/`}
                      className={
                        'btn btn-success btn-sm yekan-font'
                      }
                  >
                    پرداخت
                  </Link>
              )}
              <Link
                  to={`/factors/`}
                  className={
                    'btn btn-warning btn-sm yekan-font'
                  }
              >
                بازگشت
              </Link>
            </div>
          </div>
          <hr className={'print-none'} />
          {/* **************** FACTOR **************** */}
          <div className="main-factor">
            {/* **************** FACTOR HEADER **************** */}
            <div className="d-flex justify-content-between align-items-center">
              <img
                src={factorInfo?.logo_img}
                alt="logo"
                width={100}
                className={'img-fluid'}
              />
              <div className={'w-33-50 d-flex flex-wrap'}>
                {factorInfo?.is_official === '1' ? (
                  <>
                    <div className="border py-1 px-3 border-secondary w-50">
                      <span>شماره سیستمی :</span>
                      <span className={'ms-1'}>{factorId}</span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="border py-1 px-3 border-secondary w-50">
                      <span>شماره فاکتور :</span>
                      <span className={'ms-1'}>{factorId}</span>
                    </div>
                  </>
                )}
                <div className="border py-1 px-3 border-secondary w-50">
                  <span>تاریخ صدور :</span>
                  <span className="ms-1">{factorInfo?.invoice_date}</span>
                </div>
                {factorInfo?.is_official === '1' ? (
                  <>
                    <div className="border py-1 px-3 border-secondary w-50">
                      <span>تاریخ اعتبار :</span>
                      <span className={'ms-1'}> - </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="border py-1 px-3 border-secondary w-50">
                      <span>تاریخ پرداخت :</span>
                      <span className={'ms-1'}>
                        {factorInfo?.payment_date
                          ? factorInfo?.payment_date
                          : 'پرداخت نشده'}
                      </span>
                    </div>
                    <div className="border py-1 px-3 border-secondary w-50">
                      <span> روش پرداخت :</span>
                      <span className={'ms-1'}>
                        {factorInfo?.payment_date ? (factorInfo?.payment_type === 0 ? 'درگاه پرداخت' :
                            (factorInfo?.payment_type === 1 ? 'کارت به کارت' :
                                (factorInfo?.payment_type === 2 ? 'پرداخت ادمین' : 'کیف پول'))) : '---'
                        }
                      </span>
                    </div>
                    <div className="border py-1 px-3 border-secondary w-50">
                      <span> کد پیگیری :</span>
                      <span className={'ms-1'}>
                        {factorInfo?.ref_id ? factorInfo?.ref_id : '---'
                        }
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
            {factorInfo?.is_official === 1 && (
              <>
                {/* **************** FACTOR SELLER **************** */}
                <h5 className="factor-print-main-title mt-10">
                  مشخصات فروشنده
                </h5>
                <div className={'d-none print-show'}>
                  <table className={'table table-responsive'}>
                    <tbody>
                    <tr>
                      <td>
                        <span className={'text-subject'}>نام شرکت :</span>
                        <span className={'text-value ms-1'}>
                            {companyInfo?.company_name}
                          </span>
                      </td>
                      <td>
                          <span className={'text-subject'}>
                            شماره اقتصادی :
                          </span>
                        <span className={'text-value ms-1'}>
                            {companyInfo?.financial_no}
                          </span>
                      </td>
                      <td>
                        <span className={'text-subject'}>شماره ملی :</span>
                        <span className={'text-value ms-1'}>
                            {companyInfo?.national_no}
                          </span>
                      </td>
                      <td>
                        <span className={'text-subject'}>شماره ثبت :</span>
                        <span className={'text-value ms-1'}>
                            {companyInfo?.register_no}
                          </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className={'text-subject'}>استان :</span>
                        <span className={'text-value ms-1'}>
                            {companyInfo?.province}
                          </span>
                      </td>
                      <td>
                        <span className={'text-subject'}>شهرستان :</span>
                        <span className={'text-value ms-1'}>
                            {companyInfo?.city}
                          </span>
                      </td>
                      <td>
                        <span className={'text-subject'}>کدپستی :</span>
                        <span className={'text-value ms-1'}>
                            {companyInfo?.post_code}
                          </span>
                      </td>
                      <td>
                        <span className={'text-subject'}>تلفن/نمابر :</span>
                        <span className={'text-value ms-1'}>
                            {companyInfo?.phone}
                          </span>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={4}>
                        <span className={'text-subject'}>نشانی :</span>
                        <span className={'text-value ms-1'}>
                            {companyInfo?.address}
                          </span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div className="d-block print-none">
                  <div className="row text-detail">
                    <div className="col-12 col-md-6 col-xl-3 mt-3">
                      <span className={'text-subject'}>نام شرکت :</span>
                      <span className={'text-value ms-1'}>
                        {companyInfo?.company_name}
                      </span>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mt-3">
                      <span className={'text-subject'}>شماره اقتصادی :</span>
                      <span className={'text-value ms-1'}>
                        {companyInfo?.financial_no}
                      </span>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mt-3">
                      <span className={'text-subject'}>شماره ملی :</span>
                      <span className={'text-value ms-1'}>
                        {companyInfo?.national_no}
                      </span>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mt-3">
                      <span className={'text-subject'}>شماره ثبت :</span>
                      <span className={'text-value ms-1'}>
                        {companyInfo?.register_no}
                      </span>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mt-3">
                      <span className={'text-subject'}>استان :</span>
                      <span className={'text-value ms-1'}>
                        {companyInfo?.province}
                      </span>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mt-3">
                      <span className={'text-subject'}>شهرستان :</span>
                      <span className={'text-value ms-1'}>
                        {companyInfo?.city}
                      </span>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mt-3">
                      <span className={'text-subject'}>کدپستی :</span>
                      <span className={'text-value ms-1'}>
                        {companyInfo?.post_code}
                      </span>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mt-3">
                      <span className={'text-subject'}>تلفن/نمابر :</span>
                      <span className={'text-value ms-1'}>
                        {companyInfo?.phone}
                      </span>
                    </div>
                    <div className="col-12 mt-3">
                      <span className={'text-subject'}>نشانی :</span>
                      <span className={'text-value ms-1'}>
                        {companyInfo?.address}
                      </span>
                    </div>
                  </div>
                </div>
                {/* **************** FACTOR CUSTOMER **************** */}
                <h5 className="factor-print-main-title mt-7">مشخصات خریدار</h5>
                {userInfo?.customer_type === 1 ? (
                  <>
                    {/* **************** Haghighi **************** */}
                    <div className={'d-none print-show'}>
                      <table className={'table table-responsive'}>
                        <tbody>
                        <tr>
                          <td>
                            <span className={'text-subject'}>نام مشتری :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.full_name}
                          </span>
                          </td>
                          <td>
                          <span className={'text-subject'}>
                            شماره ملی :
                          </span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.nid}
                          </span>
                          </td>
                          <td>
                            <span className={'text-subject'}>تلفن :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.phone}
                          </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className={'text-subject'}>استان :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.province}
                          </span>
                          </td>
                          <td>
                            <span className={'text-subject'}>شهرستان :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.city}
                          </span>
                          </td>
                          <td>
                            <span className={'text-subject'}>نشانی :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.address}
                          </span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="d-block print-none">
                      <div className="row text-detail">
                        <div className="col-12 col-md-6 col-xl-4 mt-3">
                          <span className={'text-subject'}>نام مشتری :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.full_name}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4 mt-3">
                          <span className={'text-subject'}>شماره ملی :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.nid}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4 mt-3">
                          <span className={'text-subject'}>تلفن :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.phone}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4 mt-3">
                          <span className={'text-subject'}>استان :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.province}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4 mt-3">
                          <span className={'text-subject'}>شهرستان :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.city}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4 mt-3">
                          <span className={'text-subject'}>نشانی :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.address}
                      </span>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {/* **************** Hoghooghi **************** */}
                    <div className={'d-none print-show'}>
                      <table className={'table table-responsive'}>
                        <tbody>
                        <tr>
                          <td>
                          <span className={'text-subject'}>نام مشتری :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.company_name}
                          </span>
                          </td>
                          <td>
                          <span className={'text-subject'}>
                            شماره اقتصادی :
                          </span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.financial_no}
                          </span>
                          </td>
                          <td>
                            <span className={'text-subject'}>شماره ملی :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.national_no}
                          </span>
                          </td>
                          <td>
                            <span className={'text-subject'}>شماره ثبت :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.register_no}
                          </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className={'text-subject'}>استان :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.province}
                          </span>
                          </td>
                          <td>
                            <span className={'text-subject'}>شهرستان :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.city}
                          </span>
                          </td>
                          <td>
                            <span className={'text-subject'}>کدپستی :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.post_code}
                          </span>
                          </td>
                          <td>
                            <span className={'text-subject'}>تلفن/نمابر :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.phone}
                          </span>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <span className={'text-subject'}>نشانی :</span>
                            <span className={'text-value ms-1'}>
                            {userInfo?.address}
                          </span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="d-block print-none">
                      <div className="row text-detail">
                        <div className="col-12 col-md-6 col-xl-3 mt-3">
                          <span className={'text-subject'}>نام شرکت :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.company_name}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3 mt-3">
                          <span className={'text-subject'}>شماره اقتصادی :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.financial_no}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3 mt-3">
                          <span className={'text-subject'}>شماره ملی :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.national_no}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3 mt-3">
                          <span className={'text-subject'}>شماره ثبت :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.register_no}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3 mt-3">
                          <span className={'text-subject'}>استان :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.province}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3 mt-3">
                          <span className={'text-subject'}>شهرستان :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.city}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3 mt-3">
                          <span className={'text-subject'}>کدپستی :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.post_code}
                      </span>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3 mt-3">
                          <span className={'text-subject'}>تلفن/نمابر :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.phone}
                      </span>
                        </div>
                        <div className="col-12 mt-3">
                          <span className={'text-subject'}>نشانی :</span>
                          <span className={'text-value ms-1'}>
                        {userInfo?.address}
                      </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
            {/* **************** FACTOR PRODUCT **************** */}
            <h5 className="factor-print-main-title mt-7">مشخصات کالا</h5>
            <div className={'d-none d-lg-block print-show'}>
              <table className="table table-bordered mt-3 factor-table">
                <thead className={'text-center'}>
                <tr>
                  <th>ردیف</th>
                  <th>شرح خدمت یا کالا</th>
                  <th>مبلغ کل فاکتور (ریال)</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>1</td>
                  <td className="factor_product_desc"></td>
                  <td className={'text-center'}>
                    {getPrice(factorInfo?.factor_price)}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className={'d-block d-lg-none print-none'}>
              <p className="factor_product_desc m-0"></p>
              <p>
                <span>مبلغ کل (ریال)</span>
                <span className={'ms-1'}>
                  {getPrice(factorInfo?.factor_price)}
                </span>
              </p>
            </div>
            <div className="d-md-flex justify-content-end align-items-center px-md-5 print-flex">
              <div
                className={'d-flex justify-content between align-items-center'}
              >
                <img
                  src={factorInfo?.status_img}
                  alt="status"
                  className={'img-fluid'}
                />
                <div className={'text-right'}>
                  <h2>
                    <span>مالیات :</span>
                    <span className={'ms-1'}>{getPrice(factorInfo?.tax)}</span>
                    <span className={'ms-1'}>ریال</span>
                  </h2>
                  <h2>
                    <span>قابل پرداخت :</span>
                    <span className={'ms-1'}>
                      {getPrice(factorInfo?.total_payment)}
                    </span>
                    <span className={'ms-1'}>ریال</span>
                  </h2>
                </div>
              </div>
            </div>
            {/* **************** FACTOR FOOTER **************** */}
            <div className="border border-dark rounded p-3 mt-5">
              <p className="">توضیحات :</p>
            </div>
            {factorInfo?.is_official === '1' && (
              <>
                <div className="d-none print-show">
                  <div className="d-flex justify-content-between align-items-center mt-5">
                    <p className="m-0">مهر و امضا فروشنده :</p>
                    <p className="m-0">مهر و امضا خریدار‌ :</p>
                  </div>
                </div>
              </>
            )}
          </div>
        </Box>
      )}
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </>
  );
};

export default FactorDetail;
